  <template>
      <div class="body">
          <p  class="font1" style="padding-top: 13vh;">勤耕岁月学无涯，</p>
          <p  class="font1" style="padding-top: 1vh;">积学成才道路赊。</p>

          <div style="width: 80%;margin: 0 auto;margin-top: 3vh;">
            <p style="margin: 0 auto; font-size: 20px;color: #000;">2024年必修课程：</p>
            <ul>
                    <li>{{ coc[0].Name }}&nbsp;&nbsp;<span class="font3" v-if="coc[0].iscompleted===true">已完成</span><span class="font3" v-else>未完成</span></li>
                    <li>{{ coc[1].Name }}&nbsp;&nbsp;<span class="font3" v-if="coc[1].iscompleted===true">已完成</span><span class="font3" v-else>未完成</span></li>
                </ul>
            <p style="width: 100%;margin: 0 auto;font-size: 15px;color: #000;margin-top: 3vh;">**具体可登录富学宝典查看:【首页】>【个人设置】>【学习任务】**</p>
          </div>

          <div style="width: 80%;margin: 0 auto;margin-top: 3vh;">
              <p style="margin: 0 auto; font-size: 20px;color: #000;">EHS+ESG 3月主题课程推荐：</p>
              <!-- <a href="https://iedu.foxconn.com/public/play/playCourse?courseId=34060">{{ themeLink[0].Name }}</a> -->
              <ul>
                  <a href="https://iedu.foxconn.com/public/play/playCourse?courseId=34060" style="text-decoration: none;color: #000;"><li>{{ themeLink[0].Name }}</li></a>
              </ul>
          </div>


          <p class="font1" style="color: #953b5d;margin-top: 5vh;">{{ ReportData.textLab.text }}</p>
      </div>
  </template>
  
  <script>
  export default {
    props: ["ReportData"],
    components: {
     
    },
    data() {
      return {
          coc:'',
          themeLink:''
      }
    }, 
    created(){
      const coc=JSON.parse(this.ReportData.coc)
      this.themeLink=JSON.parse(this.ReportData.themeLink)
      console.log(this.themeLink,'11')
      console.log(coc,'coc');
      if(coc !== null){
        this.coc=coc
      }
    },
    computed:{
      
    },
    mounted(){
      
    }
  }
  </script>
  
  <style scoped>
  .body {
    background: url("../../assets/logo.jpg") 15px calc(100% - 20px) no-repeat,
                url("../../assets/logo1.png") right  top  no-repeat,
                url("../../assets/24February/bg.jpg")  no-repeat;
    background-size: 17% 8%,117px 50px,cover;
    width: 100%;
    height: 100vh;
}
ul{
    list-style-type: none;
    padding: 0;
    color: #000;
    margin: 0;
    /* text-align: center; */
}
li {
    align-items: center;
    /* margin-bottom: 1px;  */
}

li::before {
    content: '\2022'; /* 使用小圆点作为列表标记 */
    color: #000; /* 可根据需要调整小圆点的颜色 */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}
.font1 {
    width: 80%;
    margin: 0 auto;
    /* text-align: center; */
    font-size: 20px;
    color: #fff;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 90%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #fff;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #953b5d;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
  </style>